const { SSO_API } = require("../config");

const backEnd = SSO_API;
// const backEnd = "https://sso.poltekkes-smg.ac.id/api";
// const backEnd = "https://billing.poltekkes-smg.ac.id/api/";
module.exports = backEnd;
